// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"35":"212539898ee1c6389070","204":"88db89e6f5516c749661","357":"7d25b9293029917240e4","906":"ac667be2d104547b4256"}[chunkId] + "-" + chunkId + ".css";
};